























import {Prop, Vue} from 'vue-property-decorator';
import Component from "vue-class-component";
import {ContentVisibility, WrapperConfig} from "@/types/WrapperConfig";

@Component
export default class RecurrenceWrapper extends Vue {

  @Prop({
    type: Object,
    default: {
      status: 'valid',
      text: "Récurrence n°1",
    }
  })
  public config!: WrapperConfig;

  public isContentVisible: ContentVisibility = ContentVisibility.Hidden;

  public statusImage = {
    'valid': require('@/assets/circle-checkmark.svg'),
    'loading': '',
    'error': require('@/assets/circle-cross.svg'),
    'none': '',
  };

  public isContentVisibleImage = {
    'visible': require('@/assets/icon-angle-top.svg'),
    'hidden': require('@/assets/icon-angle-bot.svg'),
  };

  toggleVisibility() {
    this.isContentVisible = (this.isContentVisible === ContentVisibility.Hidden) ? ContentVisibility.Visible : ContentVisibility.Hidden;
  }

}


